import React from 'react';
import IconNotes from '~/assets/svg/icon-notes.svg?react';
import IconSend from '~/assets/svg/icon-send-outline.svg?react';
import SendMessageForm from '~/components/screens/Conversations/ConversationsList/ConversationDetails/SendMessage/SendMessageForm';
import useActionBar from '~/hooks/useActionBar';

import ActionTab from './ActionTab';
import CloseConversationModal from './CloseConversationModal';
import SendNoteForm from './SendNoteForm';

function ActionBar({ conversationId, isClosed, contactReason, activeMerchantId, onStatusChange }) {
  const {
    activeAction,
    toggleAction,
    showCloseModal,
    setShowCloseModal,
    sendMessageMutation,
    addNoteMutation,
    closeConversationMutation,
    handleCloseConversation,
  } = useActionBar({ conversationId, onStatusChange });

  return (
    <div className={`shrink-0 ${activeAction ? '' : 'rounded-b-sm'} overflow-hidden`}>
      <div className='flex min-h-[48px] sm:h-[48px] border-0 border-t border-solid border-grey'>
        <ActionTab
          icon={<IconSend className='w-[24px] h-[24px]' />}
          label='Nouveau message'
          mobileLabel='Message'
          active={activeAction === 'message'}
          onClick={() => toggleAction('message')}
        />
        <ActionTab
          icon={<IconNotes className='w-[24px] h-[24px]' />}
          label='Note interne'
          mobileLabel='Note'
          active={activeAction === 'note'}
          onClick={() => toggleAction('note')}
        />
        {!isClosed && <ActionTab label='Clôturer la conversation' mobileLabel='Clôturer' onClick={() => setShowCloseModal(true)} />}
      </div>
      {activeAction === 'message' && (
        <div className='p-m'>
          <SendMessageForm mutation={sendMessageMutation} contactReason={contactReason} activeMerchantId={activeMerchantId} />
        </div>
      )}
      {activeAction === 'note' && (
        <div className='p-m'>
          <SendNoteForm mutation={addNoteMutation} />
        </div>
      )}
      <CloseConversationModal
        open={showCloseModal}
        onCancel={() => setShowCloseModal(false)}
        onConfirm={handleCloseConversation}
        loading={closeConversationMutation.isPending}
      />
    </div>
  );
}

export default ActionBar;
